/** All the paries in the Norwegian parliament, per 2018. */
const parties: Party[] = [
    {
        id: 'ap',
        legend: 'AP',
        name: 'Arbeiderpartiet',
        color: '#BF4957',
    },
    {
        id: 'sp',
        legend: 'Sp',
        name: 'Senterpartiet',
        color: '#56AD4B',
    },
    {
        id: 'sv',
        legend: 'SV',
        name: 'Sosialistisk Venstreparti',
        color: '#C75893',
    },
    {
        id: 'mdg',
        legend: 'MdG',
        name: 'Miljøpartiet De Grønne',
        color: '#607D38',
    },
    {
        id: 'r',
        legend: 'R',
        name: 'Rødt',
        color: '#EB5454',
    },
    {
        id: 'krf',
        legend: 'Kr.F.',
        name: 'Kristelig Folkeparti',
        color: '#FFC95C',
    },
    {
        id: 'v',
        legend: 'V',
        name: 'Venstre',
        color: '#6CAB99',
    },
    {
        id: 'h',
        legend: 'H',
        name: 'Høyre',
        color: '#3D6B94',
    },
    {
        id: 'frp',
        legend: 'Fr.p.',
        name: 'Fremskrittspartiet',
        color: '#344557',
    },
    {
        id: 'other',
        legend: 'Andre',
        name: 'Andre',
        color: '#9B9B9B',
    },
];

/** Norwegian electoral districts */
const districts: Districts = {
    1: {
        name: 'Østfold',
        area: 5077.26,
        population: 295769,
        seats: 9,
        weighing: {
            ap: 1.1715328467153285,
            sv: 0.7333333333333334,
            r: 0.8750000000000001,
            sp: 0.8446601941747571,
            krf: 1,
            mdg: 0.8125,
            v: 0.5454545454545454,
            h: 0.9520000000000001,
            frp: 1.1513157894736843,
            alli: 1,
            demn: 1,
            helse: 1.25,
            kristne: 1,
            kyst: 1,
            libs: 1,
            pp: 2,
            blanke: 1.5,
            other: 1.2222222222222223,
        },
    },
    2: {
        name: 'Akershus',
        area: 5084.34,
        population: 615936,
        seats: 18,
        weighing: {
            ap: 0.9598540145985403,
            sv: 0.8833333333333333,
            r: 0.7916666666666666,
            sp: 0.5825242718446602,
            krf: 0.5476190476190476,
            mdg: 1.15625,
            v: 1.477272727272727,
            h: 1.24,
            frp: 0.993421052631579,
            alli: 1,
            demn: 1,
            helse: 1.4999999999999998,
            kristne: 0.33333333333333337,
            kyst: 0,
            libs: 1,
            pir: 2,
            pp: 1.4999999999999998,
            blanke: 1,
            other: 1.0555555555555556,
        },
    },
    3: {
        name: 'Oslo',
        area: 480.76,
        population: 576478,
        seats: 20,
        weighing: {
            ap: 1.0364963503649636,
            sv: 1.55,
            r: 2.625,
            sp: 0.20388349514563106,
            krf: 0.5,
            mdg: 1.875,
            v: 1.909090909090909,
            h: 1.056,
            frp: 0.625,
            alli: 1,
            demn: 1,
            helse: 0.7499999999999999,
            kristne: 0.33333333333333337,
            libs: 1,
            nkp: null,
            pir: 2,
            pp: 1,
            samfs: null,
            blanke: 0.8333333333333334,
            fi: null,
            other: 0.8333333333333333,
        },
    },
    4: {
        name: 'Hedmark',
        area: 27397.85,
        population: 196866,
        seats: 7,
        weighing: {
            ap: 1.299270072992701,
            sv: 0.9500000000000001,
            r: 0.5416666666666667,
            sp: 2.1553398058252426,
            krf: 0.42857142857142855,
            mdg: 0.5937499999999999,
            v: 0.5227272727272726,
            h: 0.612,
            frp: 0.7697368421052632,
            alli: 1,
            demn: 2,
            helse: 0.7499999999999999,
            kristne: 0.33333333333333337,
            kyst: 0,
            libs: 0.5,
            pp: 2.75,
            blanke: 1.3333333333333335,
            np: null,
            other: 1.2222222222222223,
        },
    },
    5: {
        name: 'Oppland',
        area: 25192.09,
        population: 189840,
        seats: 7,
        weighing: {
            ap: 1.281021897810219,
            sv: 0.7666666666666666,
            r: 0.7083333333333334,
            sp: 2.058252427184466,
            krf: 0.5,
            mdg: 0.7499999999999999,
            v: 0.5909090909090908,
            h: 0.6679999999999999,
            frp: 0.8026315789473684,
            alli: 1,
            demn: 1,
            helse: 1,
            kristne: 0.6666666666666667,
            kyst: 0,
            libs: 0.5,
            pp: 1,
            blanke: 1,
            other: 0.7777777777777777,
        },
    },
    6: {
        name: 'Buskerud',
        area: 15053.83,
        population: 282178,
        seats: 9,
        weighing: {
            ap: 1.0328467153284673,
            sv: 0.8333333333333334,
            r: 0.625,
            sp: 1.0485436893203883,
            krf: 0.6190476190476191,
            mdg: 0.84375,
            v: 0.8409090909090908,
            h: 1.0759999999999998,
            frp: 1.1381578947368423,
            alli: 1,
            demn: 1,
            helse: 1.4999999999999998,
            kristne: 0.6666666666666667,
            kyst: 1,
            libs: 1,
            blanke: 1.1666666666666667,
            other: 0.7222222222222222,
        },
    },
    7: {
        name: 'Vestfold',
        area: 4118.98,
        population: 249450,
        seats: 7,
        weighing: {
            ap: 1.0218978102189782,
            sv: 0.8333333333333334,
            r: 0.7916666666666666,
            sp: 0.6116504854368932,
            krf: 0.8809523809523809,
            mdg: 0.9062499999999999,
            v: 0.8636363636363635,
            h: 1.204,
            frp: 1.1118421052631577,
            alli: 1,
            demn: 1,
            helse: 1.25,
            kristne: 1,
            kyst: 1,
            libs: 1,
            pir: 2,
            blanke: 1.1666666666666667,
            other: 0.8333333333333333,
        },
    },
    8: {
        name: 'Telemark',
        area: 16157.79,
        population: 173386,
        seats: 6,
        weighing: {
            ap: 1.1642335766423357,
            sv: 0.8333333333333334,
            r: 0.8750000000000001,
            sp: 1.2524271844660193,
            krf: 1.1904761904761905,
            mdg: 0.78125,
            v: 0.6136363636363636,
            h: 0.804,
            frp: 1.0855263157894737,
            alli: 1,
            demn: 1,
            helse: 1,
            kristne: 2,
            kyst: 1,
            libs: 0.5,
            blanke: 1,
            other: 0.7777777777777777,
        },
    },
    9: {
        name: 'Aust-Agder',
        area: 11889.02,
        population: 117303,
        seats: 4,
        weighing: {
            ap: 0.927007299270073,
            sv: 0.6666666666666666,
            r: 0.5,
            sp: 0.8058252427184466,
            krf: 2.3333333333333335,
            mdg: 0.8125,
            v: 0.7499999999999999,
            h: 1.024,
            frp: 1.1381578947368423,
            alli: 1,
            demn: 2,
            helse: 1,
            kristne: 2.3333333333333335,
            kyst: 0,
            libs: 1,
            pir: 2,
            pp: 1.7499999999999998,
            blanke: 0.8333333333333334,
            other: 1.3333333333333333,
        },
    },
    10: {
        name: 'Vest-Agder',
        area: 11084.15,
        population: 186792,
        seats: 6,
        weighing: {
            ap: 0.7664233576642336,
            sv: 0.7166666666666667,
            r: 0.5833333333333334,
            sp: 0.6310679611650485,
            krf: 3,
            mdg: 0.9062499999999999,
            v: 0.8181818181818181,
            h: 1.1159999999999999,
            frp: 1.1250000000000002,
            alli: 1,
            demn: 6.999999999999999,
            helse: 0.5,
            kristne: 2.666666666666667,
            kyst: 1,
            libs: 1,
            pir: 2,
            pp: 1,
            blanke: 0.8333333333333334,
            other: 1.5,
        },
    },
    11: {
        name: 'Rogaland',
        area: 16532.21,
        population: 474058,
        seats: 14,
        weighing: {
            ap: 0.8175182481751825,
            sv: 0.65,
            r: 0.5,
            sp: 0.7281553398058251,
            krf: 2,
            mdg: 0.8125,
            v: 0.7954545454545454,
            h: 1.1520000000000001,
            frp: 1.2960526315789473,
            alli: 1,
            demn: 1,
            helse: 0.5,
            kristne: 1.6666666666666667,
            kyst: 1,
            libs: 1.4999999999999998,
            nkp: null,
            pir: 2,
            pp: 1.25,
            blanke: 1,
            verdi: null,
            other: 1.1111111111111112,
        },
    },
    12: {
        name: 'Hordaland',
        area: 22686.84,
        population: 523255,
        seats: 16,
        weighing: {
            ap: 0.832116788321168,
            sv: 1.1666666666666667,
            r: 0.8750000000000001,
            sp: 0.7378640776699028,
            krf: 1.3095238095238095,
            mdg: 1.09375,
            v: 1,
            h: 1.216,
            frp: 0.993421052631579,
            alli: 1,
            demn: 1,
            helse: 0.5,
            kristne: 1.6666666666666667,
            kyst: 1,
            libs: 1,
            pir: 2,
            blanke: 1.1666666666666667,
            fi: null,
            other: 0.888888888888889,
        },
    },
    14: {
        name: 'Sogn og Fjordane',
        area: 27110.19,
        population: 110069,
        seats: 4,
        weighing: {
            ap: 0.8978102189781023,
            sv: 0.75,
            r: 0.5416666666666667,
            sp: 2.8834951456310676,
            krf: 1.0238095238095237,
            mdg: 0.7187499999999999,
            v: 0.9318181818181817,
            h: 0.7440000000000001,
            frp: 0.6513157894736843,
            alli: 1,
            demn: 1,
            helse: 0.5,
            kristne: 1.3333333333333335,
            libs: 0.5,
            blanke: 0.8333333333333334,
            other: 0.4444444444444445,
        },
    },
    15: {
        name: 'Møre og Romsdal',
        area: 26296.62,
        population: 267203,
        seats: 8,
        weighing: {
            ap: 0.7773722627737227,
            sv: 0.65,
            r: 0.5,
            sp: 1.262135922330097,
            krf: 1.4523809523809523,
            mdg: 0.6875,
            v: 0.7954545454545454,
            h: 0.9440000000000001,
            frp: 1.467105263157895,
            alli: 1,
            demn: 1,
            kristne: 1.6666666666666667,
            kyst: 1,
            libs: 0.5,
            pp: 1.25,
            blanke: 1,
            nml: 15,
            other: 1.611111111111111,
        },
    },
    16: {
        name: 'Sør-Trøndelag',
        area: 18856,
        population: 320822,
        seats: 10,
        weighing: {
            ap: 1.1970802919708028,
            sv: 1.2833333333333334,
            r: 1.2083333333333333,
            sp: 1.0388349514563104,
            krf: 0.6428571428571429,
            mdg: 1.21875,
            v: 0.9318181818181817,
            h: 0.828,
            frp: 0.7697368421052632,
            alli: 1,
            demn: 1,
            helse: 0.5,
            kristne: 0.33333333333333337,
            kyst: 1,
            libs: 1,
            pir: 2,
            pp: 4.25,
            blanke: 1,
            other: 1.5555555555555554,
        },
    },
    17: {
        name: 'Nord-Trøndelag',
        area: 22415,
        population: 137767,
        seats: 5,
        weighing: {
            ap: 1.248175182481752,
            sv: 0.8333333333333334,
            r: 0.6666666666666667,
            sp: 2.3689320388349513,
            krf: 0.6428571428571429,
            mdg: 0.5625,
            v: 0.5,
            h: 0.5920000000000001,
            frp: 0.7565789473684211,
            alli: 1,
            demn: 1,
            helse: 1,
            kristne: 0.6666666666666667,
            kyst: 1,
            libs: 0.5,
            pir: 1,
            pp: 1.4999999999999998,
            blanke: 1,
            other: 0.9444444444444444,
        },
    },
    18: {
        name: 'Nordland',
        area: 81002.65,
        population: 243401,
        seats: 9,
        weighing: {
            ap: 0.9489051094890512,
            sv: 1.1666666666666667,
            r: 1.2083333333333333,
            sp: 1.8058252427184467,
            krf: 0.5714285714285714,
            mdg: 0.6875,
            v: 0.5909090909090908,
            h: 0.8079999999999999,
            frp: 1.0855263157894737,
            alli: 1,
            demn: 1,
            helse: 1.25,
            kristne: 0.6666666666666667,
            kyst: 2.9999999999999996,
            libs: 1,
            nkp: null,
            pir: 2,
            blanke: 1.1666666666666667,
            other: 0.888888888888889,
        },
    },
    19: {
        name: 'Troms Romsa',
        area: 41132.81,
        population: 166792,
        seats: 6,
        weighing: {
            ap: 0.8759124087591241,
            sv: 1.6833333333333333,
            r: 0.9583333333333333,
            sp: 1.4563106796116503,
            krf: 0.6190476190476191,
            mdg: 0.8749999999999999,
            v: 0.6590909090909091,
            h: 0.82,
            frp: 1.1973684210526316,
            alli: 1,
            demn: 1,
            helse: 0.7499999999999999,
            kristne: 0.6666666666666667,
            kyst: 2,
            libs: 1.4999999999999998,
            nkp: null,
            blanke: 1.3333333333333335,
            nordt: null,
            other: 0.7777777777777777,
        },
    },
    20: {
        name: 'Finnmark Finnmárku',
        area: 74293.69,
        population: 76094,
        seats: 4,
        weighing: {
            ap: 1.1678832116788322,
            sv: 1.4666666666666668,
            r: 0.625,
            sp: 1.4466019417475728,
            krf: 0.5,
            mdg: 0.65625,
            v: 0.9545454545454545,
            h: 0.5760000000000001,
            frp: 1.1842105263157896,
            alli: 2,
            demn: 2,
            helse: 1,
            kristne: 1.3333333333333335,
            kyst: 4,
            libs: 1,
            pir: 2,
            blanke: 1.6666666666666667,
            other: 1.0555555555555556,
        },
    },
};

/** Defaulting to the results from last parliamentary election */
const parliament: Results = {
    ap: {
        seats: 49,
        percentage: 27.4,
    },
    sp: {
        seats: 19,
        percentage: 10.3,
        levelingSeats: 1,
    },
    sv: {
        seats: 11,
        percentage: 6.0,
        levelingSeats: 6,
    },
    mdg: {
        seats: 1,
        percentage: 3.2,
    },
    r: {
        seats: 1,
        percentage: 2.4,
    },
    krf: {
        seats: 8,
        percentage: 4.2,
        levelingSeats: 5,
    },
    v: {
        seats: 8,
        percentage: 4.4,
        levelingSeats: 4,
    },
    h: {
        seats: 45,
        percentage: 25,
        levelingSeats: 3,
    },
    frp: {
        seats: 27,
        percentage: 15.2,
    },
    other: {
        seats: 0,
        percentage: 1.9,
    },
};

/** The results to compre all new results to */
const compare: Results = {
    ap: {
        seats: 49,
        percentage: 27.4,
    },
    sp: {
        seats: 19,
        percentage: 10.3,
    },
    sv: {
        seats: 11,
        percentage: 6.0,
    },
    mdg: {
        seats: 1,
        percentage: 3.2,
    },
    r: {
        seats: 1,
        percentage: 2.4,
    },
    krf: {
        seats: 8,
        percentage: 4.2,
    },
    v: {
        seats: 8,
        percentage: 4.4,
    },
    h: {
        seats: 45,
        percentage: 25,
    },
    frp: {
        seats: 27,
        percentage: 15.2,
    },
    other: {
        seats: 0,
        percentage: 1.9,
    },
};

/** The electoral threshold. ("Sperregrensen") */
const threshold: number = 4;

/** Potential coalitions */
const coalitions: Coalition[] = [
    {
        name: 'Blå-gul-grønn',
        parties: ['h', 'frp', 'v', 'krf'],
    },
    {
        name: 'Blågrønt flertall',
        parties: ['h', 'frp', 'v'],
    },
    {
        name: 'Bondevik 3',
        parties: ['h', 'krf', 'v', 'sp'],
    },
    {
        name: 'Rødgrønt',
        parties: ['ap', 'sp', 'sv'],
    },
    {
        name: 'Rødgrønt med rødt',
        parties: ['ap', 'sp', 'sv', 'r'],
    },
    {
        name: 'Rødgrønt med mdg',
        parties: ['ap', 'sp', 'sv', 'mdg'],
    },
];

export default {
    parties,
    districts,
    parliament,
    compare,
    threshold,
    coalitions,
};
